module.exports = __webpack_public_path__ + "img/check_icon.e2fbdd61.svg";